export async function readFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = function (e) {
            switch(e.target.error.code) {
                case e.target.error.NOT_FOUND_ERR:
                    reject('File Not Found!');
                    break;
                case e.target.error.NOT_READABLE_ERR:
                    reject('File is not readable');
                    break;
                case e.target.error.ABORT_ERR:
                    reject('Upload cancelled');
                    break; // noop
                default:
                    reject('An error occurred reading this file.');
            }
        };
        reader.onload = function (e) {
            resolve(e.target.result);
        };
        reader.readAsArrayBuffer(file);
    });
}
